var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-list',{attrs:{"sort-by":"price","items":_vm.value,"loading-count":_vm.loadingCount},scopedSlots:_vm._u([{key:"item",fn:function({ item, index }){return [_c('snow-box',{key:index,attrs:{"value":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }